import _ from 'lodash';
import { i18n } from './i18n';
import { request } from 'beans-admin-plugin';
import pluralize from 'pluralize';
import { modelData, displayText } from '@/custom_models_extend';

export const belongsToRenderCell = function({ modelName, valueColumn }) {
  const requestUrl = `/${pluralize(_.map(modelName.split('::'), str => _.snakeCase(str)).join('/'))}/read_options`

  if (!valueColumn) {
    valueColumn = 'id'
  }

  return {
    component: 'select',
    props: {
      clearable: true,
      xRemotePreload: async () => {
        return (await request.get(requestUrl, { per_page: 100 })).data.map(item => ({ value: item[valueColumn], label: displayText(item) }));
      },
      xRemoteSearch: async (keyword) => {
        return (await request.get(requestUrl, { keyword })).data.map(item => ({ value: item[valueColumn], label: displayText(item) }));
      }
    }
  }
}

export const hasManyRenderCell = function({ modelName, valueColumn }) {
  return _.merge(belongsToRenderCell({ modelName, valueColumn }), {
    props: {
      multiple: true
    }
  })
}

const components = {
  id: function() {
    return {
      renderCell: {
        component: 'input',
        props: {
          disabled: true
        }
      }
    }
  },
  type: function({ v }) {
    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          options: _.map(v.extra.options, (value) => ({ label: i18n.t(`${modelData[v.model_name]['element']}.types.${value}`), value: value }))
        }
      }
    }
  },
  belongsTo: function({ v }) {
    return {
      renderCell: belongsToRenderCell({ modelName: v.extra.model_name, valueColumn: v.extra.value_column }),
    }
  },
  hasMany: function({ v }) {
    return {
      renderCell: hasManyRenderCell({ modelName: v.extra.model_name, valueColumn: v.extra.value_column })
    }
  },
  enum: function({ v }) {
    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          options: _.map(v.extra.options, (value) => ({ label: i18n.t(`${modelData[v.model_name]['element']}.${pluralize(_.camelCase(v.column_name))}.${value}`), value: value }))
        }
      }
    }
  },
  string: function() {
    return {
      renderCell: {
        component: 'input'
      }
    }
  },
  integer: function () {
    return {
      renderCell: {
        component: 'input',
        props: {
          type: 'number'
        }
      }
    }
  },
  decimal: function () {
    return {
      renderCell: {
        component: 'input',
        props: {
          type: 'number'
        }
      }
    }
  },
  float: function () {
    return {
      renderCell: {
        component: 'input',
        props: {
          type: 'number'
        }
      }
    }
  },
  text: function () {
    return {
      renderCell: {
        component: 'editor',
      }
    }
  },
  boolean: function () {
    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          options: [{ label: i18n.t('bean.yes'), value: true }, { label: i18n.t('bean.no'), value: false }]
        }
      }
    }
  },
  date: function () {
    return {
      renderCell: {
        component: 'datePicker',
        props: {
          valueFormat: 'yyyy-MM-dd'
        }
      }
    }
  },
  time: function () {
    return {
      renderCell: {
        component: 'timePicker',
      }
    }
  },
  datetime: function () {
    return {
      renderCell: {
        component: 'dateTimePicker',
      }
    }
  },
  tag: function() {
    return {
      renderCell: {
        component: 'select',
        props: {
          clearable: true,
          multiple: true,
          allowCreate: true,
          xRemotePreload: async () => {
            const { data } = await request.get('/acts_as_taggable_on/tags/read_options', { per_page: 100 })
            return _.map(data, ({ name }) => ({ value: name, label: name }))
          },
          xRemoteSearch: async (keyword) => {
            const { data } = await request.get('/acts_as_taggable_on/tags/read_options', { keyword })
            return _.map(data, ({ name }) => ({ value: name, label: name }))
          }
        }
      }
    }
  },
}

export default function(columns) {
  let hash = {}

  _.forEach(columns, (v, k) => {
    if (modelData[v.model_name]) {
      hash[k] = _.merge({
        prop: k,
        label: i18n.t(`${modelData[v.model_name]['element']}.${_.camelCase(v.column_name)}`),
      }, components[_.camelCase(v.column_type)]({ k, v }))
    } else {
      console.error(`admin_models/all.js文件不包含model: ${v.model_name}`)
    }
  })

  return hash
}
